import Lights from 'shared/components/lights';

const layoutTemplate = require('templates/popups/layout.jst.jade')

const Popup = {
  ui: {
    body: 'body',
    root: '.popup',
    icon: '.popup__icon',
    close: '.popup__close',
    content: '.popup__content'
  },

  new: function(title, template) {
    var object = Object.create(Popup);
    object.title = title;
    object.template = template;

    object.render();

    object.bindClose();
    object.hideNavbar(object.navbarSelector());
    Lights.off.bind(object)();

    return object;
  },

  title: "Default Title",
  template: "",

  html: null,

  close: function(){
    this.showNavbar(this.navbarSelector());
    $(this.ui.root).remove();
    Lights.on();
    this.toggleOverflow();
  },

  content: function(content) {
    $(this.html).find(this.ui.content).html(content);
    return this.html;
  },

  bindClose: function() {
    this.html.find(this.ui.close).on('click', function() {
      this.close();
    }.bind(this));
  },

  render: function(){
    this.html = $(layoutTemplate({ title: this.title, template: this.template }));
    this.scrollTop();
    this.toggleOverflow();
  },

  scrollTop() {
    $(this.ui.body).scrollTop(0);
  },

  toggleOverflow() {
    var bodyOverflow = document.body.style.overflow;
    if(bodyOverflow) {
      document.body.style.overflow = "";
    } else {
      document.body.style.overflow = "auto";
    }
  },

  navbarSelector() {
    return $('header#navbar');
  },

  hideNavbar($element) {
    $element.addClass('hide-navbar');
  },

  showNavbar($element) {
    $element.removeClass('hide-navbar');
  }
};

export default Popup;
